import React from 'react';

import styled, { TC } from '@benzinga/themetron';

export const PreferenceContainer: React.FC<
  React.PropsWithChildren<{
    subtitle?: string | React.ReactElement;
    title?: string | React.ReactElement;
  }>
> = props => (
  <PreferenceContainerDiv>
    <PreferencesHeader subtitle={props.subtitle} title={props.title} />
    <ScrollContainer>{props.children}</ScrollContainer>
  </PreferenceContainerDiv>
);

const PreferenceContainerDiv = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  min-height: 1px;
  width: 100%;
  font-size: 14px;
  padding: 0em 1em;
`;

const ScrollContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex: 1;
  padding-top: 0.75em;
  flex-direction: column;
  .flex-row {
    flex-direction: row;
  }
  .justify-center {
    justify-content: center;
  }
`;

const PreferencesHeader: React.FC<{
  subtitle?: string | React.ReactElement;
  title?: string | React.ReactElement;
}> = props => (
  <Header>
    {props.title && <HeaderTitle>{props.title}</HeaderTitle>}
    {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
  </Header>
);

const Header = styled(TC.Column)`
  background: ${({ theme }) => theme.colors.backgroundInactive};
  border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundInactive};
  flex-shrink: 0;
  padding-top: 1em;
`;

const HeaderTitle = styled(TC.Row)`
  color: ${({ theme }) => theme.colors.foreground};
  font-size: 1.5em;
  font-weight: 300;
  padding-bottom: 0.5em;
  padding-left: 16px;
  text-transform: uppercase;
`;

const Subtitle = styled(TC.Row)`
  color: ${({ theme }) => theme.colors.foregroundInactive};
  font-size: 0.875em;
  font-weight: 400;
  margin-bottom: 1em;
  margin-top: -0.5em;
  padding-left: 16px;
`;
